import { ReparoApi } from './index';
import {
    adaptOrder,
    type ProcurementOrder,
    type RawOrder,
} from './procurement-order';

// A shipment is an ordinary purchase_orders row (reuses ProcurementOrder)
// linked to a parent mother order. The list excludes the in-production bucket.

export type Shipment = ProcurementOrder & {
    motherOrderId: string | null;
    motherOrderNumber: string | null;
    /** The parent order's WMS PO code — a GRN can only be raised once this exists. */
    motherWmsPoCode: string | null;
};

type RawShipment = RawOrder & {
    motherOrderId?: string | null;
    motherOrderNumber?: string | null;
    motherWmsPoCode?: string | null;
};

const adaptShipment = (raw: RawShipment): Shipment => ({
    ...adaptOrder(raw),
    motherOrderId: raw.motherOrderId ?? null,
    motherOrderNumber: raw.motherOrderNumber ?? null,
    motherWmsPoCode: raw.motherWmsPoCode ?? null,
});

export const listShipments = async (): Promise<Shipment[]> => {
    const raw = await ReparoApi<RawShipment[]>({
        method: 'GET',
        url: '/shipments',
    });
    return (raw ?? []).map(adaptShipment);
};

/**
 * One shipment/PO with items + expected timeline — works for mother-linked
 * shipments AND standalone synced POs, so the side panel opens from anywhere.
 */
export const getShipmentDetail = async (poId: string): Promise<Shipment> => {
    const raw = await ReparoApi<RawShipment>({
        method: 'GET',
        url: `/shipments/${encodeURIComponent(poId)}/detail`,
    });
    return adaptShipment(raw);
};
